export default __webpack_public_path__ + "static/media/cd_light.8679a8fc.png";